import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { class: "m-auto transform translate-x-1/3" }
const _hoisted_3 = {
  key: 0,
  class: "text-muted mt-1"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"20px !important"},
  class: "material-icons-outlined animate-spin"
}, " sync ", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "" }
const _hoisted_7 = {
  key: 0,
  class: "text-yellow-900 material-icons-outlined mx-auto",
  style: {"font-size":"20px !important","padding-top":"3.5px !important"}
}
const _hoisted_8 = {
  key: 1,
  class: "mx-auto",
  style: {"padding-top":"-5px !important"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (
					_ctx.params.value.execution_results &&
					_ctx.params.value.execution_results.state === 'running'
				)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : (_openBlock(), _createBlock(_component_Btn, {
            key: 1,
            variant: 'icon',
            outline: true,
            style: {"margin-top":"7.5px !important","line-height":"1 !important"},
            class: _normalizeClass({
					'transition-opacity duration-75 hover:opacity-100 opacity-70': _ctx.hasNullishScore,
				})
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.hasNullishScore)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, " pending_actions "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.params.value.score), 1))
              ])
            ]),
            _: 1
          }, 8, ["class"]))
    ])
  ]))
}